document.addEventListener('DOMContentLoaded', function() {
  const tabButtons = document.querySelectorAll('.collection-tab-button');
  const contentContainers = document.querySelectorAll('.collection-tab-content');
  const sliderContainers = document.querySelectorAll('.collection-tabs-slider');
  
  tabButtons.forEach(button => {
    button.addEventListener('click', function() {
      const tabId = this.dataset.tabId;
      
      // Update active tab button
      tabButtons.forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
      
      // Hide all content
      contentContainers.forEach(content => content.classList.remove('active'));
      sliderContainers.forEach(slider => slider.classList.remove('active'));
      
      // Show selected content
      const selectedContent = document.getElementById(`tab-content-${tabId}`);
      const selectedSlider = document.getElementById(`slider-${tabId}`);
      
      if (selectedContent) selectedContent.classList.add('active');
      if (selectedSlider) selectedSlider.classList.add('active');
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const slider = document.getElementById("tabsTrack");
  const prev = document.querySelector(".tabs-arrow.prev");
  const next = document.querySelector(".tabs-arrow.next");
  const track = document.querySelector(".tabs-scrollbar-track");
  const thumb = document.querySelector(".tabs-scrollbar-thumb");

  if (!slider) return;

  function updateArrows() {
    const maxScroll = slider.scrollWidth - slider.clientWidth;

    // Start
    if (slider.scrollLeft <= 5) {
      prev.setAttribute("disabled", "disabled");
      prev.classList.add("is-disabled");
    } else {
      prev.removeAttribute("disabled");
      prev.classList.remove("is-disabled");
    }

    // End
    if (slider.scrollLeft >= maxScroll - 5) {
      next.setAttribute("disabled", "disabled");
      next.classList.add("is-disabled");
    } else {
      next.removeAttribute("disabled");
      next.classList.remove("is-disabled");
    }
  }

  function updateThumb() {
    const visible = slider.clientWidth;
    const total = slider.scrollWidth;
    const maxScroll = total - visible;

    if (maxScroll <= 0) {
      thumb.style.width = "0px";
      thumb.style.left = "0px";
      return;
    }

    const thumbWidth = Math.max((visible / total) * track.clientWidth, 20);
    thumb.style.width = thumbWidth + "px";

    const percent = slider.scrollLeft / maxScroll;
    const maxMove = track.clientWidth - thumb.offsetWidth;
    thumb.style.left = percent * maxMove + "px";
  }

  prev.addEventListener("click", () => {
    slider.scrollBy({ left: -200, behavior: "smooth" });
  });

  next.addEventListener("click", () => {
    slider.scrollBy({ left: 200, behavior: "smooth" });
  });

  slider.addEventListener("scroll", () => {
    updateThumb();
    updateArrows();
  });

  window.addEventListener("resize", () => {
    updateThumb();
    updateArrows();
  });

  setTimeout(() => {
    updateThumb();
    updateArrows();
  }, 200);
});

document.querySelectorAll("slider-component").forEach(component => {
  const slider = component.querySelector(".slider");
  const track = component.querySelector(".slider-scrollbar-track");
  const thumb = component.querySelector(".slider-scrollbar-thumb");

  if (!slider || !track || !thumb) return;

  const updateThumb = () => {
    const visible = slider.clientWidth;
    const total = slider.scrollWidth;
    const maxScroll = total - visible;

    // Thumb size
    const thumbWidth = (visible / total) * track.clientWidth;
    thumb.style.width = `${thumbWidth}px`;

    // Thumb position
    const percent = slider.scrollLeft / maxScroll;
    const maxThumbMove = track.clientWidth - thumb.offsetWidth;
    thumb.style.left = `${percent * maxThumbMove}px`;
  };

  slider.addEventListener("scroll", updateThumb);
  window.addEventListener("resize", updateThumb);
  setTimeout(updateThumb, 100);

  /* Dragging */
  let dragging = false;

  thumb.addEventListener("mousedown", e => {
    dragging = true;
    document.body.classList.add("no-select");
  });

  document.addEventListener("mouseup", () => {
    dragging = false;
    document.body.classList.remove("no-select");
  });

  document.addEventListener("mousemove", e => {
    if (!dragging) return;

    const rect = track.getBoundingClientRect();
    let x = e.clientX - rect.left;
    x = Math.max(0, Math.min(x, rect.width));

    const percent = x / rect.width;
    const maxScroll = slider.scrollWidth - slider.clientWidth;
    slider.scrollLeft = percent * maxScroll;
  });

  /* Clicking on track */
  track.addEventListener("click", e => {
    const rect = track.getBoundingClientRect();
    const percent = (e.clientX - rect.left) / rect.width;
    const maxScroll = slider.scrollWidth - slider.clientWidth;
    slider.scrollLeft = percent * maxScroll;
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const tabButtons = document.querySelectorAll('.collection-tab-button');
  const headingEl = document.getElementById('dynamic-tab-heading');
  const descEl = document.getElementById('dynamic-tab-description');

  function activateTab(button) {
    const heading = button.dataset.heading || button.dataset.defaultHeading;
    const desc = button.dataset.description || '';
    const color = button.dataset.color || '#101D3A';

    // Update text
    headingEl.textContent = heading;
    descEl.textContent = desc;

    // Reset all buttons
    tabButtons.forEach(btn => {
      btn.classList.remove('active');
      btn.style.background = '#ffffff';
      btn.style.color = '';
    });

    // Active styles
    button.classList.add('active');
    button.style.background = color;
    button.style.color = '#fff';
  }

  tabButtons.forEach(button => {
    button.addEventListener('click', function() {
      activateTab(this);
    });
  });

  // Trigger first tab on load
  if (tabButtons.length) activateTab(tabButtons[0]);
});






document.addEventListener('DOMContentLoaded', () => {

  const tabs = document.querySelectorAll('.tab-btn');
  const descBox = document.getElementById('dynamic-tab-desc');

  function activateTab(btn) {
    const wrapper = btn.closest('.article-tabs-wrapper');

    wrapper.querySelectorAll('.tab-btn').forEach(b => {
      b.classList.remove('active');
      b.style.background = '';
      b.style.color = '';
    });

    wrapper.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));

    btn.classList.add('active');

    const target = document.getElementById(btn.dataset.target);
    target.classList.add('active');

    // Update left description
    if (descBox && btn.dataset.subheading) {
      descBox.innerHTML = btn.dataset.subheading;
    }

    // Active tab color
    if (btn.dataset.color) {
      btn.style.background = btn.dataset.color;
      btn.style.color = "#fff";
    }

    // 🟢 FIX: Recalculate slider buttons when tab changes
    const grid = target.querySelector('.article-grid-scroll');
    const prevBtn = target.querySelector('.slider-button--prev');
    const nextBtn = target.querySelector('.slider-button--next');

    if (grid) {
      const maxScroll = grid.scrollWidth - grid.clientWidth;

      if (prevBtn) prevBtn.disabled = grid.scrollLeft <= 5;
      if (nextBtn) nextBtn.disabled = grid.scrollLeft >= maxScroll - 5;
    }
  }


  // CLICK EVENTS
  tabs.forEach(btn => {
    btn.addEventListener('click', () => activateTab(btn));
  });

  // ✅ AUTO LOAD FIRST TAB
  const firstTab = document.querySelector('.tab-btn.active');
  if (firstTab) activateTab(firstTab);

  // Slider arrows
  document.querySelectorAll('.tab-panel').forEach(panel => {
    const grid = panel.querySelector('.article-grid-scroll');
    const prevBtn = panel.querySelector('.slider-button--prev');
    const nextBtn = panel.querySelector('.slider-button--next');

    if (!grid) return;

    const updateButtons = () => {
      const maxScroll = grid.scrollWidth - grid.clientWidth;

      if (prevBtn) prevBtn.disabled = grid.scrollLeft <= 5;
      if (nextBtn) nextBtn.disabled = grid.scrollLeft >= maxScroll - 5;
    };

    // Arrow click
    panel.querySelectorAll('.slider-button').forEach(button => {
      button.addEventListener('click', function () {
        const scrollAmount = grid.clientWidth * 0.8;
        grid.scrollLeft += (this.name === 'next' ? scrollAmount : -scrollAmount);
      });
    });

    // Update on scroll
    grid.addEventListener('scroll', updateButtons);

    // Initial check
    updateButtons();
  });


  // Scrollbar drag sync
  document.querySelectorAll('.article-grid-scroll').forEach(grid => {
    const panel = grid.closest('.tab-panel');
    const thumb = panel.querySelector('.slider-scrollbar-thumb');
    const track = panel.querySelector('.slider-scrollbar-track');

    const syncThumb = () => {
      if (!thumb || !track) return;
      const maxScroll = grid.scrollWidth - grid.clientWidth;
      const scrollPercent = grid.scrollLeft / maxScroll;
      const availableSpace = track.clientWidth - thumb.clientWidth;
      thumb.style.left = (scrollPercent * availableSpace) + "px";
    };

    grid.addEventListener('scroll', syncThumb);

    if (thumb) {
      let isDragging = false;
      let startX, startScroll;

      thumb.addEventListener('mousedown', (e) => {
        isDragging = true;
        startX = e.pageX;
        startScroll = grid.scrollLeft;
        grid.style.scrollBehavior = 'auto';
        document.body.style.userSelect = 'none';
      });

      window.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        const moveX = e.pageX - startX;
        const maxScroll = grid.scrollWidth - grid.clientWidth;
        const availableTrack = track.clientWidth - thumb.clientWidth;
        const scrollChange = (moveX / availableTrack) * maxScroll;
        grid.scrollLeft = startScroll + scrollChange;
      });

      window.addEventListener('mouseup', () => {
        isDragging = false;
        grid.style.scrollBehavior = 'smooth';
        document.body.style.userSelect = 'auto';
      });
    }
  });

});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-section-id]').forEach(function (section) {

    const tabsSlider = section.querySelector('.collection-tabs-buttons');
    if (!tabsSlider) return;

    const prevBtn = section.querySelector('.tabs-arrow.prev');
    const nextBtn = section.querySelector('.tabs-arrow.next');
    const scrollbarThumb = section.querySelector('.tabs-scrollbar-thumb');

    /* ---------------- SCROLLBAR ---------------- */
    const updateScrollbar = () => {
      if (!scrollbarThumb) return;

      const scrollWidth = tabsSlider.scrollWidth - tabsSlider.clientWidth;
      const scrollLeft = tabsSlider.scrollLeft;

      const trackWidth = scrollbarThumb.parentElement.clientWidth;
      const thumbWidth = Math.max((tabsSlider.clientWidth / tabsSlider.scrollWidth) * trackWidth, 20);
      const maxThumbLeft = trackWidth - thumbWidth;
      const thumbLeft = scrollWidth > 0 ? (scrollLeft / scrollWidth) * maxThumbLeft : 0;

      scrollbarThumb.style.width = thumbWidth + 'px';
      scrollbarThumb.style.transform = `translateX(${thumbLeft}px)`;
    };

    /* ---------------- BUTTON DISABLE LOGIC ---------------- */
    const updateArrows = () => {
      const maxScroll = tabsSlider.scrollWidth - tabsSlider.clientWidth;

      if (prevBtn) prevBtn.disabled = tabsSlider.scrollLeft <= 5;
      if (nextBtn) nextBtn.disabled = tabsSlider.scrollLeft >= maxScroll - 5;
    };

    /* ---------------- ARROW CLICK ---------------- */
    nextBtn?.addEventListener('click', () => {
      tabsSlider.scrollBy({ left: 150, behavior: 'smooth' });
    });

    prevBtn?.addEventListener('click', () => {
      tabsSlider.scrollBy({ left: -150, behavior: 'smooth' });
    });

    /* ---------------- EVENTS ---------------- */
    tabsSlider.addEventListener('scroll', () => {
      updateScrollbar();
      updateArrows();
    });

    window.addEventListener('resize', () => {
      updateScrollbar();
      updateArrows();
    });

    /* ---------------- INITIAL STATE ---------------- */
    updateScrollbar();
    updateArrows();
  });
});

